import React, { forwardRef } from 'react';

import MaterialTable, {MTableToolbar,MTableCell,MTableAction,MTableActions,MTableHeader,MTableBody,MTableBodyRow} from 'material-table';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';

import { makeStyles, Paper } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#00093F', 
    '& .MuiTable-root': {
        backgroundColor: 'transparent', 

        '& .MuiTableHead-root': {
            
            '& .MuiTableRow-head': {
                boxShadow: '1px 1px 1px 0 rgb(0 0 0 / 14%)',
                
                '& .MuiTableCell-head': {
                    border: 'none',
                    color: 'rgb(121 121 121)',
                    backgroundColor: '#FFF', 
                    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)',                        
                    '&:first-child': {
                        borderTopLeftRadius: '6px'
                    }, 
                    '&:last-child': {
                        borderTopRightRadius: '6px'
                    },
                    '& .MuiTableSortLabel-active': {
                        color: '#6a5cff'
                    } 

                }
            }
        },

        '& .MuiTableBody-root': {
            backgroundColor: '#FFF', 
            '& .MuiTableRow-root': {
                '& .MuiTableCell-body': {
                    color: '#005d84'
                },
                '& .MuiTableCell-sizeSmall': {
                    borderBottomColor: 'whitesmoke',
                    padding: '0px 24px 0px 16px',
                    '& .MuiSvgIcon-colorAction': {
                        color: '#7E7E7E'
                    },
                    '& .MuiCheckbox-root': {
                        padding: 0,
                        margin: 0,
                    }
                },
                '& .MuiIconButton-root': {
                    color: '#009EE0',
                },
                '& .MuiIconButton-root.Mui-disabled': {
                    color: '#7979797a',
                    '& .MuiSvgIcon-root': {
                        color: '#7979797a !important',
                    } 
                }
            }
        },

        '& .MuiTableFooter-root': {
            backgroundColor: '#FFF',
            '& .MuiTablePagination-toolbar': {
                color: '#7E7E7E',
                '& .MuiTypography-colorInherit': {
                    color: '#7E7E7E',
                    '& .MuiTablePagination-input': {
                        color: '#7E7E7E',
                    }
                },
                '&. MuiList-root': {
                    color: '#7E7E7E',
                },
                '& .MuiTablePagination-selectIcon': {
                    color: '#009EE0',
                },
                '& .MuiPaper-root': {
                    color: '#009EE0',
                },
                '& .MuiIconButton-root': {
                    color: '#009EE0',
                },
                '& .MuiIconButton-root.Mui-disabled': {
                    color: '#7979797a',
                },
                '& .MuiButton-contained.Mui-disabled': {
                    color: '#7979797a',
                },
                '& .MuiButton-sizeSmall': {
                    color: 'rgb(121 121 121)',
                }
            }

        }
    }
  },
  toolbarWrapper: {
    maxHeight: '60px', 
    backgroundColor: '#00093F', 
    color: '#fff',
    '& .MuiToolbar-gutters': {
      paddingLeft: 0,
      paddingRight: 0,
    },
    '& .MuiInputAdornment-positionStart': {
        marginLeft: '8px'
    },
    '& .MuiIconButton-root': {
        margin: '2px',
        padding: '4px',
        borderRadius: '4px',
        backgroundColor: '#FFF', 
    }
  },
  headerRoot: {
  },
  bodyRoot: {
  },
  cellRoot: {
    // border: 'none',
    // '& .MuiTableCell-sizeSmall': {
    //     border: 'none',
    //     padding: '0px 24px 0px 16px'
    // }
  },
  actionRoot: {
    // border: 'none',
    // '& .MuiTableCell-sizeSmall': {
    //     border: 'none',
    //     padding: '0px 24px 0px 16px'
    // }
  },
  actionsRoot: {
    // border: 'none',
    // '& .MuiTableCell-sizeSmall': {
    //     border: 'none',
    //     padding: '0px 24px 0px 16px'
    // }
  }
});

const DataTable = (props) => {
    const classes = useStyles();

    return (
        <MaterialTable
            icons={{
                Search: forwardRef((props, ref) => <SearchIcon color="primary" {...props} ref={ref} />), 
                Export: forwardRef((props, ref) => <DownloadIcon color="primary" {...props} ref={ref} />), 
                ResetSearch: forwardRef((props, ref) => <ClearIcon color="primary" {...props} ref={ref} />)
            }}
            options={{
                showTitle: false,
                padding: 'dense',
                pageSize: props.pageSize ? props.pageSize : window.innerHeight > 930 ? 20 : window.innerHeight > 722 ? 15 : 10,
                pageSizeOptions: [15, 20, 35, 50],
                paginationType: 'stepped',
                exportAllData: true,
                exportButton: true,
                exportCsv: props.exportCsv ? props.exportCsv : undefined,                               
                // minBodyHeight: props.minBodyHeight ? props.minBodyHeight : '68vh',
                exportDelimiter: ';',
                exportFileName: 'data-table-export_'+Date.now(),
                emptyRowsWhenPaging: false,
                // toolbarButtonAlignment: 'left',
                selection: props.selection === undefined ? false : props.selection,
                showTextRowsSelected: false,
                actionsColumnIndex: -1,
                searchFieldStyle: {
                    color: 'rgb(121 121 121)',
                    borderRadius: '2px',
                    backgroundColor: '#FFFFFF',
                    boxShadow: 'inset 0 1px 3px 0 rgba(0,0,0,0.14)',
                    minWidth: '500px'                    
                },
                searchFieldAlignment: 'left',
                // headerStyle: {
                //     color: 'rgb(121 121 121)',
                //     borderRadius: '8px',
                //     // marginTop: '0px',
                //     // paddingTop: '0px',
                //     // paddingBottom: '0px',
                //     border: 'none',
                //     boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)'
                // },                         
                rowStyle: {
                    color: 'rgb(121 121 121)',
                    border: '0px',
                    overflowWrap: 'break-word'
                }
            }}
            components={{
                Container: props => (
                    <Paper className={classes.root} {...props}/>
                ),
                Toolbar: props => (
                    <div className={classes.toolbarWrapper}>
                        <MTableToolbar {...props}/>
                    </div>
                ),
                Header: props => (
                    <MTableHeader className={classes.headerRoot} {...props}/>
                ),
                Body: props => (
                    <MTableBody  className={classes.bodyRoot} {...props}/>
                ),
                Cell: props => (
                    <MTableCell  className={classes.cellRoot} {...props}/>
                ),
                Action: props => (
                    <MTableAction  className={classes.actionRoot} {...props}/>
                ),
                Actions: props => (
                    <MTableActions className={classes.actionsRoot} {...props}/>
                ),
                Row: props => {
                    const propsCopy = { ...props };
                    for (const action of propsCopy.actions) {
                        if (action.toggleData) {
                            action.icon = () => propsCopy.data[action.toggleData] ? <ToggleOffIcon color="action" /> : <ToggleOnIcon color="primary" />
                        }
                        if (action.disabledData) {
                            action.disabled = propsCopy.data[action.disabledData];
                        }
                    }
                    return <MTableBodyRow {...propsCopy} />
                  }  
            }}            
            {...props}
        />        
    );
}

export default DataTable;